"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const sixLayouts = [
    {
        id: art_layout_names_1.default.GRID_PORTRAIT,
        displayName: 'Grid',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.37040280210157617,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.37040280210157617,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.28633975481611207,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.4019264448336252,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3169877408056042,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4448336252189142,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5726795096322241,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.GREY_COUCH_BLANKET,
                tiles: [
                    {
                        id: 'couch_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2224168126094571,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2224168126094571,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.06654991243432574,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.3239929947460595,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_TOWER,
        displayName: 'Tower',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.10683012259194395,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.2224168126094571,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.3380035026269702,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.45359019264448336,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.5691768826619965,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46234676007005254,
                            y: 0.6847635726795096,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.138353765323993,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.3021015761821366,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3809106830122592,
                            y: 0.4658493870402802,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.138353765323993,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.3021015761821366,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.4658493870402802,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.05253940455341506,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.30998248686514884,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4133099824868651,
                            y: 0.5674255691768827,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.05253940455341506,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.30998248686514884,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.6042031523642732,
                            y: 0.5674255691768827,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_ORGANIC,
        displayName: 'Organic',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3345008756567426,
                            y: 0.2381786339754816,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3712784588441331,
                            y: 0.35376532399299476,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4264448336252189,
                            y: 0.19001751313485113,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.46322241681260945,
                            y: 0.35376532399299476,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.2381786339754816,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'couch_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5910683012259195,
                            y: 0.35376532399299476,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH2_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.2574430823117338,
                            y: 0.16549912434325745,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3126094570928196,
                            y: 0.329246935201401,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.38528896672504376,
                            y: 0.07180385288966724,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4404553415061296,
                            y: 0.329246935201401,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'couch_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5761821366024519,
                            y: 0.16549912434325745,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'couch_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6313485113835376,
                            y: 0.329246935201401,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_VERTICAL,
        displayName: 'Vertical',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5411558669001751,
                            y: 0.36339754816112085,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5770577933450087,
                            y: 0.2478108581436077,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5770577933450087,
                            y: 0.5271453590192644,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6690017513134852,
                            y: 0.1987740805604203,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6690017513134852,
                            y: 0.31436077057793343,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6690017513134852,
                            y: 0.4299474605954466,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.3476357267950963,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5630472854640981,
                            y: 0.18388791593695272,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5630472854640981,
                            y: 0.6050788091068301,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.11033274956217162,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.27408056042031526,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.43782837127845886,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_STAIRWAY,
        displayName: 'Stairway',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.21978984238178634,
                            y: 0.3432574430823117,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.3161120840630473,
                            y: 0.29159369527145357,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4124343257443082,
                            y: 0.23905429071803852,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.18739054290718038,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6050788091068301,
                            y: 0.13485113835376533,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7014010507880911,
                            y: 0.08318739054290718,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'stairway_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.2591943957968476,
                            y: 0.35814360770577935,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3555166374781086,
                            y: 0.25569176882662,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.4316987740805604,
                            y: 0.1339754816112084,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.489492119089317,
                            y: 0.25569176882662,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    },
                    {
                        id: 'stairway_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5280210157618214,
                            y: 0.08318739054290718,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'stairway_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6619964973730298,
                            y: 0.1085814360770578,
                            width: 0.07880910683012259,
                            height: 0.1042031523642732
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.STAIRWAY_LAYOUTS,
                tiles: [
                    {
                        id: 'couch_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.1085814360770578,
                            y: 0.4973730297723292,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'couch_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2434325744308231,
                            y: 0.3231173380035026,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'couch_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.3345008756567426,
                            y: 0.15061295971978983,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'couch_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.44395796847635727,
                            y: 0.3239929947460595,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    },
                    {
                        id: 'couch_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.46935201401050786,
                            y: 0.053415061295971976,
                            width: 0.18213660245183888,
                            height: 0.2521891418563923
                        }
                    },
                    {
                        id: 'couch_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.669877408056042,
                            y: 0.10157618213660245,
                            width: 0.11646234676007006,
                            height: 0.15499124343257442
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_BLOCKS,
        displayName: 'Blocks',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5516637478108581,
                            y: 0.17162872154115585,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5516637478108581,
                            y: 0.287215411558669,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5516637478108581,
                            y: 0.4028021015761821,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6436077057793345,
                            y: 0.17162872154115585,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6436077057793345,
                            y: 0.287215411558669,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6436077057793345,
                            y: 0.4028021015761821,
                            width: 0.07443082311733801,
                            height: 0.09807355516637478
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.14010507880910683,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.30385288966725044,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.46760070052539404,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.62784588441331,
                            y: 0.14010507880910683,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.62784588441331,
                            y: 0.30385288966725044,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.62784588441331,
                            y: 0.46760070052539404,
                            width: 0.11033274956217162,
                            height: 0.14623467600700527
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.HALL_LAYOUTS,
                tiles: [
                    {
                        id: 'plain_wall_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.05779334500875657,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.31523642732049034,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5,
                            y: 0.5726795096322241,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.05779334500875657,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.31523642732049034,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    },
                    {
                        id: 'plain_wall_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.690893169877408,
                            y: 0.5726795096322241,
                            width: 0.1733800350262697,
                            height: 0.23992994746059546
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_MOLECULAR,
        displayName: 'Molecular',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.23029772329246936,
                            y: 0.30823117338003503,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.34938704028021017,
                            y: 0.27845884413309985,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.39404553415061294,
                            y: 0.4868651488616462,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5131348511383538,
                            y: 0.22066549912434325,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'couch 228cm_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5131348511383538,
                            y: 0.36952714535901926,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6768826619964974,
                            y: 0.39929947460595444,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.10770577933449929,
                            y: 0.21978984238178634,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.2670753064798599,
                            y: 0.16112084063047286,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.35201401050787934,
                            y: 0.48774080560420313,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5113835376532383,
                            y: 0.10245183887915937,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'couch 228cm_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.5113835376532383,
                            y: 0.3108581436077058,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'couch 228cm_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.7556917688266184,
                            y: 0.36952714535901926,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_CLOUD,
        displayName: 'Cloud',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.45709281961471104,
                            y: 0.43870402802101577,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4868651488616462,
                            y: 0.11646234676007006,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5718038528896673,
                            y: 0.43870402802101577,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7311733800350263,
                            y: 0.15148861646234676,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.7311733800350263,
                            y: 0.29597197898423816,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7311733800350263,
                            y: 0.5,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_SPARSE,
        displayName: 'Sparse',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5087565674255692,
                            y: 0.29859894921190894,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.553415061295972,
                            y: 0.1234676007005254,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.553415061295972,
                            y: 0.5332749562171629,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6987740805604203,
                            y: 0.14973730297723292,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.6987740805604203,
                            y: 0.5035026269702276,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7250437828371279,
                            y: 0.3283712784588441,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.531523642732049,
                            y: 0.29859894921190894,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.553415061295972,
                            y: 0.1234676007005254,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5542907180385289,
                            y: 0.5332749562171629,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6987740805604203,
                            y: 0.09369527145359019,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.6987740805604203,
                            y: 0.5035026269702276,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7215411558669002,
                            y: 0.3283712784588441,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.DOOR_LAYOUTS,
                tiles: [
                    {
                        id: 'door_6_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.46147110332749564,
                            y: 0.13747810858143608,
                            width: 0.2224168126094571,
                            height: 0.30035026269702275
                        }
                    },
                    {
                        id: 'door_6_2',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.46147110332749564,
                            y: 0.4859894921190893,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_3',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.5980735551663747,
                            y: 0.4859894921190893,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_4',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7346760070052539,
                            y: 0.08056042031523643,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    },
                    {
                        id: 'door_6_5',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.7346760070052539,
                            y: 0.25569176882662,
                            width: 0.13747810858143608,
                            height: 0.18213660245183888
                        }
                    },
                    {
                        id: 'door_6_6',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.7793345008756567,
                            y: 0.4859894921190893,
                            width: 0.09281961471103327,
                            height: 0.12259194395796848
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SIX_SQUARE,
        displayName: 'Grid',
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'square_8x8_6_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5683012259194395,
                            y: 0.39404553415061294,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_6_2',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5683012259194395,
                            y: 0.27933450087565675,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_6_3',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.45359019264448347,
                            y: 0.39404553415061294,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_6_4',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.45359019264448325,
                            y: 0.27933450087565675,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_6_5',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.3388791593695274,
                            y: 0.39404553415061294,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    },
                    {
                        id: 'square_8x8_6_6',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.3388791593695272,
                            y: 0.27933450087565675,
                            width: 0.09281961471103327,
                            height: 0.09281961471103327
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'square_12x12_6_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5901926444833625,
                            y: 0.39404553415061294,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_6_2',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.5901926444833625,
                            y: 0.23467600700525393,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_6_3',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.4308231173380035,
                            y: 0.39404553415061294,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_6_4',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.4308231173380035,
                            y: 0.23467600700525393,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_6_5',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.2714535901926445,
                            y: 0.39404553415061294,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    },
                    {
                        id: 'square_12x12_6_6',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.2714535901926445,
                            y: 0.23467600700525393,
                            width: 0.13747810858143608,
                            height: 0.13747810858143608
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.COUCH_LAYOUTS,
                tiles: [
                    {
                        id: 'couch 228cm_6_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.39404553415061294,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_6_2',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.6330998248686515,
                            y: 0.14973730297723292,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_6_3',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.38879159369527144,
                            y: 0.39404553415061294,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_6_4',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.38879159369527144,
                            y: 0.14973730297723292,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_6_5',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.14448336252189142,
                            y: 0.39404553415061294,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    },
                    {
                        id: 'couch 228cm_6_6',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.14448336252189142,
                            y: 0.14973730297723292,
                            width: 0.2224168126094571,
                            height: 0.2224168126094571
                        }
                    }
                ]
            }
        ]
    }
];
exports.default = sixLayouts;
//# sourceMappingURL=six.js.map